import { NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { MatButtonModule } from '@angular/material/button';
import { SidepanelComponent } from 'src/app/layout/sidepanel/sidepanel.component';
import { FilterConfig, FilterTypes, Services } from 'src/app/types/filter-config';
import { CountrySelectorComponent } from '../country-selector/country-selector.component';
import { ServiceSelectorComponent } from '../service-selector/service-selector.component';
import { SortSelectorComponent } from '../sort-selector/sort-selector.component';

/**
 * Custom filter sidepanel holding multiple controls
 */
@Component( {
    selector: 'riege-filter-controls',
    imports: [CountrySelectorComponent, ServiceSelectorComponent, SortSelectorComponent, MatButtonModule, NgIf, SidepanelComponent],
    templateUrl: './filter-controls.component.html',
    styleUrl: './filter-controls.component.scss',
    standalone: true
} )
export class FilterControlsComponent {
    /** reference on selected country */
    selectedCountry: string = '';

    /** reference on selected services */
    selectedSevices: Services;

    /** reference on selected sort direction */
    selectedSorting;

    /** reference on filter config */
    filters?: FilterConfig;

    /** flags, to control which filter components should be shown */
    filterByCountry = false;
    filterByServices = false;
    filterBySorting = false;

    constructor(
        @Inject( MAT_DIALOG_DATA ) public filterConfig: FilterConfig,
        public dialogRef: MatDialogRef<FilterControlsComponent>
    ) {
        /** keep a copy of filter config input for reset */
        this.filters = { ...filterConfig };

        /** set predefined filters from config  */
        this.selectedCountry = filterConfig.filter.countryCode;
        this.selectedSevices = filterConfig.filter.services;
        this.selectedSorting = filterConfig.filter.sorting.sortDirection;

        // toogle flag to show/hide controls
        this.filterByCountry = filterConfig.filterByCountry ? filterConfig.filterByCountry : false;
        this.filterByServices = filterConfig.filterByServices ? filterConfig.filterByServices : false;
        this.filterBySorting = filterConfig.filterBySorting ? filterConfig.filterBySorting : false;
    }

    /** store selected country */
    countryChanged( $event: string ) {
        this.selectedCountry = $event;
    }

    /** store selected services */
    servicesChanged( $event: Services ) {
        this.selectedSevices = $event;
    }

    /** store selected services */
    sortingChanged( $event = undefined ) {
        this.selectedSorting = $event;
    }

    /** combine filters, close dialog and pass filters to service */
    resetFilters() {
        this.selectedCountry = this.filters!.filter.countryCode;
        this.selectedSevices = this.filters!.filter.services;
        this.selectedSorting = this.filters!.filter.sorting.sortDirection;
    }

    /** helper function to passed changed filters to parent component */
    setFilters() {
        const filters = {} as FilterTypes;

        if ( this.filterByCountry ) filters['countryCode'] = this.selectedCountry;
        if ( this.filterByServices ) filters['services'] = this.selectedSevices;
        if ( this.filterBySorting ) filters['sorting'] = {
            sort: this.filterConfig.filter.sorting.sort,
            sortDirection: this.selectedSorting
        };


        this.dialogRef.close( filters );
    }
}
